import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { IToken } from './token-model';

export type LogicType = 'ALL' | 'ANY' | 'XOR' | 'NOR' | 'SINGLE';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  hasPermission(permissions: string[], logic: LogicType = 'ANY'): boolean {
    const token = this.getToken();
    if (!token || !token.functionalities) {
      return false;
    }

    const rolePermissions = JSON.parse(token.functionalities);

    switch (logic) {
      case 'ALL':
        return permissions.every((p) => rolePermissions.includes(p));
      case 'ANY':
        return permissions.some((p) => rolePermissions.includes(p));
      case 'XOR':
        return (
          permissions.filter((p) => rolePermissions.includes(p)).length === 1
        );
      case 'NOR':
        return permissions.every((p) => !rolePermissions.includes(p));
      case 'SINGLE':
        return permissions.includes(rolePermissions[0]);
      default:
        return false;
    }
  }

  private getToken(): IToken | null {
    const token = localStorage.getItem('token');
    if (!token) return null;

    const decoded: any = jwtDecode(token);
    return decoded as IToken;
  }
}
